import { Injectable } from '@angular/core';

export interface BrowserNavigationCallbacks {
  onBackNavigation: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class BrowserNavigationService {
  private callbacks: BrowserNavigationCallbacks | null = null;
  private isListening = false;
  private stateId: number = 0;

  constructor() {
    // Initialize with a unique state ID
    this.stateId = Date.now();
  }

  /**
   * Start listening to browser navigation events
   * @param callbacks - Object with onBackNavigation callback function
   */
  startListening(callbacks: BrowserNavigationCallbacks): void {
    this.callbacks = callbacks;

    if (!this.isListening) {
      // Add popstate event listener
      window.addEventListener('popstate', this.handlePopState.bind(this));
      this.isListening = true;
    }
  }

  /**
   * Stop listening to browser navigation events
   */
  stopListening(): void {
    if (this.isListening) {
      window.removeEventListener('popstate', this.handlePopState.bind(this));
      this.isListening = false;
    }
    this.callbacks = null;
  }

  /**
   * Handle browser popstate events (back/forward button clicks)
   */
  private handlePopState(event: PopStateEvent): void {
    // Execute callback for business logic (like saving form state)
    if (this.callbacks?.onBackNavigation) {
      this.callbacks.onBackNavigation();
    }
  }
}

 